<template>
  <div class="source-navigator has-border-light is-radius-large has-background-white">
    <div
      class="is-flex is-justify-content-space-between is-align-items-center px-1 has-background-secondary"
    >
      <div class="is-flex">
        <ButtonView
          type="is-ghost icon-button"
          class="is-rounded p-1"
          :disabled="currentIndex === 0"
          @click="goToPrevious"
          :data-e2e="AICypressAttribute.views.CLARA_SOURCE_NAVIGATOR_PREV"
        >
          <i class="cls cls-arrow-back is-relative xy-t-1 is-size-6" />
        </ButtonView>
        <ButtonView
          type="is-ghost icon-button"
          class="is-rounded p-1 m-l--5"
          :disabled="currentIndex === totalSources - 1"
          @click="goToNext"
          :data-e2e="AICypressAttribute.views.CLARA_SOURCE_NAVIGATOR_NEXT"
        >
          <i class="cls cls-arrow-forward is-relative xy-t-1 is-size-6" />
        </ButtonView>
      </div>

      <span class="has-text-grey is-size-7 m-r-5">{{ currentIndex + 1 }}/{{ totalSources }}</span>
    </div>

    <ClaraSource
      :document="currentDocument"
      :source="currentSource"
      width="250px"
      :has-border="false"
    />
  </div>
</template>

<script>
import ClaraSource from '@/modules/ai/components/presentational/ClaraSource.vue';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraSourceNavigator',
  emits: ['navigation-change'],
  components: {
    ClaraSource,
    ButtonView
  },
  props: {
    documents: {
      type: Array,
      required: true
    },
    similarityData: {
      type: Array,
      required: true
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  static: {
    AICypressAttribute
  },
  data() {
    return {
      currentIndex: this.initialIndex
    };
  },
  computed: {
    totalSources() {
      return this.documents.length;
    },
    currentDocument() {
      return this.documents[this.currentIndex];
    },
    currentSource() {
      return this.similarityData[this.currentIndex];
    }
  },
  methods: {
    goToPrevious() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        this.$emit('navigation-change', this.currentIndex);
      }
    },
    goToNext() {
      if (this.currentIndex < this.totalSources - 1) {
        this.currentIndex += 1;
        this.$emit('navigation-change', this.currentIndex);
      }
    }
  },
  watch: {
    initialIndex: {
      handler(newIndex) {
        this.currentIndex = newIndex;
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.source-navigator {
  min-width: var(--ce-250px);

  > div {
    border-top-left-radius: var(--ce-radius-large) !important;
    border-top-right-radius: var(--ce-radius-large) !important;
  }
}

:deep(.button) {
  &[disabled] {
    border-color: transparent !important;
    background-color: transparent !important;
  }
  &:hover {
    box-shadow: none !important;
  }
}
</style>
